import axios from 'axios';

export async function fetchGasStationsList() {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}dalkan/stations`)
        return response.data
    } catch (error) {
        console.error(error)
        throw error;
    }
}

export async function registerNewUser(userInfo) {
    try {
        await axios.post(`${process.env.REACT_APP_API_URL}users/signup`, userInfo);
    } catch (error) {
        console.error(error)
        throw error;
    }
}

export async function sendErrorForm(dalkanInfo) {
    try {
        await axios.post(`${process.env.REACT_APP_API_URL}dalkan/request_approval`, dalkanInfo);
    } catch (error) {
        console.error(error)
        throw error;
    }
}


// WEBPACK FOOTER //
// ./src/apiGateway.js